// extracted by mini-css-extract-plugin
module.exports = {"gradientBorder":"GradientBorder_gradientBorder__M0_kb","gradientBorderContent":"GradientBorder_gradientBorderContent__v2WyM"};